import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PhoneDisplay } from "@/components/PhoneDisplay";
import { formatPhone } from "@/lib/phone";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Logo } from "@/components/Logo";
import { MapPin, Clock, Globe, Facebook, Instagram, MessageCircle, Store } from "lucide-react";

export default function PublicDealerProfile() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.get(`/dealers/public/${id}`).then((r) => setD(r.data)).catch(() => setErr(true)); }, [id]);

  const links = d ? [
    { icon: Globe, label: "Sito web", url: d.website },
    { icon: Facebook, label: "Facebook", url: d.facebook },
    { icon: Instagram, label: "Instagram", url: d.instagram },
    { icon: MessageCircle, label: "WhatsApp", url: d.whatsapp ? `https://wa.me/${formatPhone(d.whatsapp).full.replace(/[^0-9]/g, "")}` : null },
  ].filter((x) => x.url) : [];

  return (
    <div className="min-h-screen bg-background" data-testid="public-dealer-profile-page">
      <header className="border-b border-border px-6 py-4 flex items-center justify-between">
        <Logo size={22} />
        <Link to="/dealers"><Button variant="outline" size="sm">← Tutti i dealer</Button></Link>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
        {err && <Card className="p-10 text-center glow-border"><p className="text-muted-foreground">Dealer non trovato.</p></Card>}
        {d && (
          <Card className="p-8 glow-border">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-primary/15 text-primary flex items-center justify-center"><Store className="w-6 h-6" /></div>
              <div>
                <h1 className="font-head text-2xl font-bold">{d.company_name || d.name}</h1>
                {d.on_street && <Badge variant="outline" className="mt-1">Negozio su strada</Badge>}
              </div>
            </div>
            {d.address && (
              <p className="text-sm text-muted-foreground flex items-center gap-2 mt-5"><MapPin className="w-4 h-4" /> {d.address}
                <a className="text-primary ml-2" target="_blank" rel="noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(d.address)}`}>Apri in Maps</a>
              </p>
            )}
            {d.opening_hours && <p className="text-sm text-muted-foreground flex items-start gap-2 mt-3"><Clock className="w-4 h-4 mt-0.5" /> <span className="whitespace-pre-line">{d.opening_hours}</span></p>}
            {d.services && (<div className="mt-5"><p className="text-xs uppercase tracking-wider text-muted-foreground">Servizi</p><p className="text-sm mt-1 whitespace-pre-line">{d.services}</p></div>)}
            {links.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-6">
                {links.map((l) => (
                  <a key={l.label} href={l.url} target="_blank" rel="noreferrer" data-testid={`dealer-social-${l.label.toLowerCase()}`}>
                    <Button variant="outline" size="sm" className="gap-2 h-auto min-h-9 whitespace-normal py-2"><l.icon className="w-4 h-4" /> {l.label}{l.label === "WhatsApp" && <PhoneDisplay value={d.whatsapp} data-testid="public-dealer-whatsapp" />}</Button>
                  </a>
                ))}
              </div>
            )}
          </Card>
        )}
      </main>
    </div>
  );
}
